import React from "react";
import ProductCategoryListingContainer from "../../containers/ProductCategoryListingContainer";
import { OneRow } from "../../core/layouts";

const ProductCategoryView = () => {
  return <OneRow section={<ProductCategoryListingContainer />} />;
};

export default ProductCategoryView;
